import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { environment } from '../../../../environments/environment.uat-stage';
import { CommunityService } from '../../../utility/services/community.service';

@Component({
  selector: 'registration-consent-box',
  templateUrl: './registration-consent-box.component.html',
  styleUrl: './registration-consent-box.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RegistrationConsentBoxComponent implements OnInit {
  @Output() consentChecked = new EventEmitter<boolean>();
  clientId: number = 0;
  isConsentChecked: boolean;
  isProduction = environment.production;

  constructor(private communityService: CommunityService) {}

  ngOnInit(): void {
    this.clientId = this.communityService.current.ClientId;
  }

  handleConsentChecked(event: boolean): void {
    this.isConsentChecked = event;
    this.consentChecked.emit(event);
  }
}
